module.exports = __webpack_public_path__ + "static/media/webdesign-services-img70.72f295e7.jpg";